import { createAsyncThunk } from '@reduxjs/toolkit';
import selectApiBaseUrl from '../../env/selectors/selectApiBaseUrl';

export default createAsyncThunk('recordings/loadConversionStatus', async (payload, { getState }) => {
  const options = {
    method: 'GET',
    headers: {
      authorization: sessionStorage.getItem('authToken'),
      'Content-Type': 'application/json',
      'x-api-version': '2.0',
    },
  };
  const apiBaseUrl = selectApiBaseUrl(getState());
  const { sourceType, id } = payload;
  const response = await fetch(`${apiBaseUrl}/conversions/${sourceType}/${id}`, options);
  if (!response.ok) {
    throw new Error(`Unable to fetch conversion status for ${id}, ${sourceType}`);
  }
  const json = await response.json();

  return json;
});
